import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { t } from 'utils';

import styles from './Widget.module.scss';

export interface IWidget extends HTMLAttributes<HTMLDivElement> {
  data: string | number;
  title: string;
}

const AppWidget: FC<IWidget> = (props) => {
  const { data, title, className } = props;
  const rootClassName = classNames(styles.root, className);

  return (
    <div className={rootClassName}>
      <span className={styles.data}>{data}</span>
      <span className={styles.name}>{t(title)}</span>
    </div>
  );
};

export default AppWidget;
